const translation = {
  Product: "Бүтээгдэхүүн",
  "Header.productNav": "LUKKEY Бүтээгдэхүүн",
  Feature: "Онцлог",
  "About Us": "Бидний тухай",
  FAQ: "Түгээмэл асуултууд",
  "Privacy Policy": "Нууцлалын бодлого",
  "Help Center": "Тусламжийн төв",
  "Header.infoMenu": "Бусад",
  "Header.appNow": "Апп авах",
  "Header.appModal.title": "LUKKEY аппыг одоо ашигла",
  "Header.appModal.subtitle": "Албан ёсны LUKKEY гар утасны аппыг авахын тулд платформоо сонгоно уу.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "iPhone дээр албан ёсны аппыг суулгана уу.",
  "Header.appModal.iosButton": "Нээх",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Google Play-ээс албан ёсны Android аппыг аваарай.",
  "Header.appModal.googlePlayButton": "Нээх",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Хамгийн сүүлийн албан ёсны APK-г шууд татаж авна уу.",
  "Header.appModal.androidButton": "Татах",
  "Header.appModal.note": "Зөвхөн албан ёсны гар утасны таталт. Хамгийн сүүлийн хувилбарыг дээрх холбоосоор авна уу.",
  "Academy": "Академи",
  "Legal": "Хууль эрх зүй",
  "AboutUs.title": "LUKKEY-ийн тухай",
  "AboutUs.lede": "LUKKEY нь дижитал хөрөнгийн өмчлөлд хамгийн өндөр аюулгүй байдлыг бий болгоход зориулагдсан Швейцарийн тоног төхөөрөмжийн түрийвчний брэнд юм.",
  "AboutUs.vision.closing": "Таны түлхүүр. Таны хөрөнгө. Таны ирээдүй.",
  "AboutUs.quote": "LUKKEY нь хүмүүс ба дижитал хөрөнгийн хооронд аюулгүй байдлын давхаргыг бий болгодог.",
  "AboutUs.block1": "LUKKEY нь Швейцарт төвтэй. Аюулгүй self-custody-д зориулсан тоног төхөөрөмжийн түрийвч дээр төвлөрдөг.",
  "AboutUs.block2": "Бүтээгдэхүүнүүд нь secure element, эвдлэн нэвтрэхээс хамгаалах хамгаалалт, бүрэн offline архитектурыг хослуулдаг. Зорилго нь private key-үүдийг тусгаарлагдсан орчинд хадгалах явдал юм.",
  "AboutUs.block3": "Систем нь Wi‑Fi, USB эсвэл шууд сүлжээний хамааралгүйгээр бүтээгдсэн. Хурууны хээний хандалт, NFC нөөцлөх хэрэгсэл, өргөн asset support нь өдөр тутмын хэрэглээнд практик байлгадаг.",
  "AboutUs.block5": "LUKKEY нь үндсэн firmware болон software-д нээлттэй, аудит хийх боломжтой хандлагыг баримталдаг. Аюулгүй байдлын тухай мэдэгдлүүд шалгаж, баталгаажуулж болохуйц байх ёстой.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Дэмжлэгийн хүсэлт",
  "WarrantySupport.intro": "Дэмжлэгийн хүсэлт илгээхийн тулд доорх мэдээллийг бөглөнө үү.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Асуудлын товч",
  "WarrantySupport.form.issueTitle.placeholder": "Товч хураангуй оруулна уу",
  "WarrantySupport.form.warrantyType.label": "Хүсэлтийн төрөл",
  "WarrantySupport.form.warrantyType.placeholder": "Хүсэлтийн төрлийг сонгох",
  "WarrantySupport.form.warrantyType.product": "Төхөөрөмжийн асуудал",
  "WarrantySupport.form.warrantyType.service": "Апп/акаунтын асуудал",
  "WarrantySupport.form.warrantyType.replacement": "Бусад",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Асуудал эсвэл хүсэлтийг дэлгэрэнгүй тайлбарлана уу",
  "WarrantySupport.form.submit": "Дэмжлэгийн хүсэлт илгээх",
  "WarrantySupport.alert.success": "Таны дэмжлэгийн хүсэлт илгээгдлээ!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Тусламжийн төв",
  "HelpCenter.intro":
    "LUKKEY Тусламжийн төвд тавтай морилно уу! Хэрэв та криптовалютын ертөнцөд шинэхэн эсвэл cold wallet-оо ашиглахад тусламж хэрэгтэй бол зөв газартаа байна. Манай cold wallet шийдэл нь таны дижитал хөрөнгийг хамгийн аюулгүйгээр хадгалах, удирдах боломжийг олгодог. Доор хамгийн түгээмэл асуултуудын хариулт болон алдааг засах зөвлөмжүүдийг олох болно.",
  "HelpCenter.section4.title": "Нэмэлт тусламж хэрэгтэй юу?",
  "HelpCenter.section4.intro":
    "Онлайнаар дэмжлэгийн хүсэлтээ эхлүүлбэл цаг хэмнэнэ, бид таныг мэргэжилтэнтэй холбож өгнө. Аюулгүй байдлын үүднээс албан ёсны дэмжлэг таны сэргээх хэллэг эсвэл хувийн түлхүүрийг хэзээ ч асуухгүй:",
  "HelpCenter.contact.hint": "Товчийг ашиглан дэмжлэгийн хүсэлт илгээгээд, бид имэйлээр холбогдоно.",
  "HelpCenter.cta.warranty": "Дэмжлэгийн хүсэлт илгээх",
  brandName: "LUKKEY",
  tagline: "Өмнө нь хэзээ ч байгаагүй криптовалютыг удирдах",
  description:
    "Манай апп-тай санхүүгийн эрх чөлөөнд хөтлөх аялалаа эхлүүлээрэй. Манай дэвшилтэт хөлдөгчний технологиор хөрөнгөө хамгаалаарай, мөн санхүүгээ илүү ухаалаг, үр ашигтайгаар удирдаарай. Таны санхүүгийн сайн сайхан байдал бидний тэргүүлэх priority юм.",
  "home.seoTitle": "LUKKEY | Аюулгүй self-custody-д зориулсан Швейцарийн hardware wallet",
  "home.seoDescription": "LUKKEY нь cold wallet аюулгүй байдал, private key-ийн offline хамгаалалт, хурууны хээтэй нэвтрэлт, NFC backup-д төвлөрсөн Швейцарийн hardware wallet брэнд бөгөөд self-custody-г илүү аюулгүй болгоход тусалдаг.",
  learnMore: "Дэлгэрэнгүй",
  "Lock Your Crypto, Securely": "Таны криптог аюулгүй байдлаар хаах",
  Testimonials: "Тэмдэглэл",
  Testimonial1:
    "Би энэ хөлдөгчийг хэдэн сар хэрэглэж байна, түүний найдвартай байдал болон аюулгүй байдлын функцууд надад ихээхэн сэтгэгдэл төрүүлсэн. Маш өндөр санал болгож байна!",
  Testimonial2:
    "Энэ хөлдөгч миний хүлээлтээс давсан! Хэрэглэхэд энгийн интерфейс болон шилдэг аюулгүй байдал нь крипто валютыг жинхэнэ сонирхогчдын хувьд зайлшгүй хэрэгсэл болгодог.",
  Testimonial3:
    "Би өмнө нь хэд хэдэн хөлдөгчийг ашиглаж үзсэн боловч энэ нь ялгардаг. Түүний гоёмсог дизайн болон дэвшилтэт функцууд нь крипто хөрөнгөө удирдахыг хялбар болгосон.",
  "John Doe": "Жон Доу",
  "Cryptocurrency Enthusiast": "Криптографийн сонирхогч",
  "Jane Smith": "Жейн Смит",
  "Crypto Security Advocate": "Крипто аюулгүй байдлын өмгөөлөгч",
  "Alex Johnson": "Алекс Жонсон",
  "Investment Analyst": "Хөрөнгө оруулалтын шинжээч",
  "Touchscreen Interface": "Тусгай дэлгэцтэй интерфейс",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Манай интуитив интерфейсийн тусламжтайгаар крипто хөрөнгийг удирдах нь амархан бөгөөд таны дижитал активуудаар хурдан, хялбар навигаци хийх боломжийг олгодог. Энэхүү интерфейс нь хурдан гүйлгээ болон аюулгүй менежментийг боломжтой болгодог.",
  "Bluetooth Connectivity": "Bluetooth холболт",
  "Wireless syncing with your devices for real-time updates.":
    "Таны төхөөрөмжүүдтэй утасгүй синхрончлол хийж, бодит цагийн шинэчлэлтийг авах.",
  "Airtag Tracking": "Airtag байршил тогтоох",
  "Track your wallet easily with built-in Airtag.":
    "Хялбархан Airtag ашиглан таны түрийвчийг хайж олоорой.",
  "Secure Chip Technology": "Аюулгүй чип технологи",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Дэвшилтэт аюулгүй байдлын чипээр тоноглогдсон бөгөөд таны үнэ цэнэтэй дижитал активуудыг зөвшөөрөлгүй нэвтрэх болон кибер аюулуудын эсрэг хүчтэй хамгаалалттай.",
  "Cross-Platform Support": "Хөндлөн платформ дэмжлэг",
  "Works with various platforms for easy accessibility.":
    "Төрөл бүрийн платформтой ажиллахад хялбар хандах боломжийг олгодог.",
  AboutUsDescription1:
    "LUKKEY-д бид таны криптовалютын активуудыг аюулгүйгээр удирдах өндөр чанартай шийдлүүдийг санал болгож байна.",
  AboutUsDescription2:
    "Манай төв оффис Швейцарийн Цуг хотод байрладаг. Туршлагатай мэргэжилтнүүдийн багтайгаар бид дижитал валютын зах зээлийн байнга өөрчлөгдөж буй орчинд инноваци хийх, зохицохыг зорьдог.",
  BlockchainNetworksSupported: "Дэмжигдсэн блокчэйн сүлжээнүүд",
  CryptocurrenciesSupported: "6,000 гаруй криптовалютыг дэмжих",
  Years: "Жил",
  ExpertiseInSecurity: "Аюулгүй байдлын мэргэжилтнүүд",
  FrequentlyAskedQuestions: "Түгээмэл асуултууд",
  WhatIsColdWallet: "Холын халаас гэж юу вэ?",
  ColdWalletDescription:
    "Холын халаас нь таны криптовалютын активуудыг интернет холболтоос гадуур хадгалдаг криптовалютын халаас бөгөөд энэ нь хакердах болон бусад онлайн аюулуудыг багасгадаг. Интернетэд холбогдсон, байнга гүйлгээ хийхэд тохиромжтой халуун халааснуудаас ялгаатай нь, холын халаас нь урт хугацааны хадгалалтанд илүү тохиромжтой бөгөөд өндөр хамгаалалттай байдаг.",
  HowToSetUpColdWallet: "Холын халаасыг хэрхэн тохируулах вэ?",
  ColdWalletSetupDescription:
    "Холын халаасыг тохируулах нь ерөнхийдөө аюулгүй, интернетгүй төхөөрөмж дээр угсралтыг хийх явцтай байдаг. Танд засварлагдсан төхөөрөмжийг алдаж эсвэл эвдрэх үед таны активуудыг олоход шаардлагатай сэргээх үг үүсгэж, аюулгүй хадгалах хэрэгтэй. Дэлгэрэнгүй зааврыг худалдан авалттайгаа хамт өгдөг бөгөөд тохиргооны процессыг гүйцэтгэхэд амар байдаг.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Таны холын халаасуудтай нийцэх криптовалютууд ямар вэ?",
  CryptocurrenciesCompatibilityDescription:
    "Манай холын халаасууд нь Bitcoin, Ethereum, Litecoin зэрэг гол криптовалютуудыг болон олон төрлийн альткойныг дэмждэг. Дэмжигдсэн криптовалютуудын бүрэн жагсаалтыг үзэхийн тулд манай вэбсайтыг үзээрэй эсвэл бүтээгдэхүүний гарын авлагад хандана уу.",
  HowToSecureColdWallet: "Холын халаасыг хэрхэн аюулгүй байлгах вэ?",
  ColdWalletSecurityDescription:
    "Холын халаасыг аюулгүй байлгахын тулд сэргээх үгсийг аюулгүй, хувийн байршилд хадгалах, хэзээ ч хэнд ч хуваалцахгүй байх, биометрийн хаалга эсвэл аюулгүй хадгаламжийн хайрцаг зэргийг ашиглах талаар бодож үзэх хэрэгтэй. Албан ёсны вэбсайтаас халаасны програм хангамжийг тогтмол шинэчлэх нь ч аюулгүй байдлыг нэмэгдүүлэхэд тусална.",
  ColdWalletNotWorking:
    "Хэрэв миний холын халаас ажиллахгүй байгаа эсвэл алдаа гарч байгаа бол юу хийх вэ?",
  ColdWalletErrorDescription:
    "Хэрэв таны холын халаасанд асуудал гарах бол хэрэглэгчийн гарын авлагын асуудал шийдвэрлэх хэсгийг шалгана уу. Илүү нарийн асуудал гарвал манай дэмжлэгийн багтай холбоо барина уу. Дэмжлэгийн үйл явцыг хурдсгахын тулд таны төхөөрөмжийн мэдээллийг бэлэн байлгах хэрэгтэй.",
  Community: "Олон нийтийн",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "Шинэ мэдээллүүдийг авах, асуулт асуух болон бусад хэрэглэгчидтэй холбогдохын тулд дуртай платформ дээрээ бидэнтэй нэгдээрэй.",
  "Subscribe.title": "Бүтээгдэхүүний шинэчлэлт авах",
  "Subscribe.subtitle":
    "Крипто чиг хандлагыг бид танд зориулан хянаж өгнө. Бүтээгдэхүүний шинэчлэлт, зах зээлийн ойлголт болон онцгой давуу эрхүүд — шууд таны имэйлд.",
  "Subscribe.placeholder": "Имэйл хаягаа оруулна уу",
  "Subscribe.button": "Бүтээгдэхүүний шинэчлэлд бүртгүүлэх",
  "Subscribe.input.aria": "Имэйл хаяг оруулах талбар",
  "Subscribe.success":
    "Бүртгүүлсэнд баярлалаа! Баталгаажуулах имэйлийг шалгана уу.",
  "Subscribe.error": "Бүртгэл амжилтгүй боллоо. Дараа дахин оролдоно уу.",
  "Subscribe.invalid": "Зөв имэйл хаяг оруулна уу.",
  "Subscribe.privacy":
    "Таны имэйлийг зөвхөн манай товхимол болон шинэчлэлт илгээхэд ашиглана. Та хүссэн үедээ имэйл доторх холбоосоор бүртглээсээ гарах боломжтой.",
  "Subscribe.learnMore":
    "Бид таны өгөгдөл болон эрхийг хэрхэн зохицуулдгийг дэлгэрэнгүй үзэх.",
  "Subscribe.popupCompact.title": "Шинэчлэлтэй байгаарай",
  "Subscribe.popupCompact.subtitle":
    "Бүтээгдэхүүний шинэчлэлт ба аюулгүй байдлын мэдээлэл. Спамгүй.",
  "Subscribe.popupCompact.button": "Бүртгүүлэх",
  "Subscribe.popupCompact.privacy":
    "Зөвхөн и-мэйл. Хэзээд цуцалж болно.",
  "SubscribeConfirmed.alt.success": "Бүртгэл баталгаажлаа",
  "SubscribeConfirmed.alt.failed": "Бүртгэл амжилтгүй боллоо",
  "SubscribeConfirmed.title.success": "Бүртгэл баталгаажлаа",
  "SubscribeConfirmed.title.failed": "Бүртгэл амжилтгүй боллоо",
  "SubscribeConfirmed.message.success":
    "Таны имэйлийг баталгаажуулсанд баярлалаа. Таны бүртгэл идэвхжлээ. Тавтай морилох имэйл таны шуудангийн хайрцагт илгээгдлээ.",
  "SubscribeConfirmed.message.failed":
    "Баталгаажуулах холбоос буруу эсвэл хугацаа нь дууссан байна. Нүүр хуудас руу буцаж дахин бүртгүүлнэ үү.",
  "SubscribeConfirmed.cta.backHome": "Нүүр хуудас руу буцах",
  "SubscribeConfirmed.note.unsubscribe":
    "Та манай имэйлийн холбоосоор хүссэн үедээ бүртгэлээ цуцалж болно.",
  // ===== MarketView i18n =====
  "MarketView.title": "Зах зээлийн самбар",
  "MarketView.loading": "Ачааллаж байна...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Энэ самбарыг дүрслэхэд алдаа гарлаа",
  "MarketView.unknownError": "Тодорхойгүй алдаа",

  // ===== Common i18n =====
  "Common.refresh": "Шинэчлэх",
  "Common.toggleSeriesVisibility": "Энэ цувааг хар/нуух",
  "Common.error": "Алдаа",
  "Common.dataUpdateTime": "Мэдээлэл шинэчлэгдсэн цаг",
  "Common.loading": "Ачааллаж байна...",
  "Common.noDataSource": "Өгөгдөл алга (эх сурвалж өгөгдөөгүй)",

  // ===== Common ranges =====
  "Common.to": "хүртэл",
  "Common.clear": "Цэвэрлэх",
  "Common.range.thisMonth": "Энэ сар",
  "Common.range.lastMonth": "Өнгөрсөн сар",
  "Common.range.last2": "Сүүлийн 2 сар",
  "Common.range.last3": "Сүүлийн 3 сар",
  "Common.range.last6": "Сүүлийн 6 сар",
  "Common.range.thisYear": "Энэ жил",
  "Common.range.all": "Бүгд",
  "Common.range.custom": "Захиалгат",
  "Common.showFilters": "Шүүлтүүрийг харуулах",
  "Common.hideFilters": "Шүүлтүүрийг нуух",
  "Common.search": "Хайх",
  "Common.priority": "Нэн тэргүүний байдал",
  "Common.owner": "Хариуцагч",
  "Common.collaborator": "Хамтран ажиллагч",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Арын хэсгийн data/youtube_stats.json татах",
  "YouTubeTab.downloadJson": "youtube_stats.json татах",
  "YouTubeTab.loading": "YouTube үзүүлэлтүүдийг ачааллаж байна...",
  "YouTubeTab.errorHint":
    "Хэрэв API түлхүүр тохируулагдаагүй бол backend/.env дахь YOUTUBE_API_KEY эсвэл GOOGLE_API_KEY-г тохируулж backend-ийг дахин асаана уу.",
  "YouTubeTab.header.totalViews": "Нийт үзэлт (олон суваг, нэгж: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Нийт бүртгэгчид (олон суваг, нэгж: 10k)",
  "YouTubeTab.dist.views": "Үзэлтийн тархалт (10k)",
  "YouTubeTab.dist.subscribers": "Бүртгэгчдийн тархалт (10k)",
  "YouTubeTab.card.location": "Байршил:",
  "YouTubeTab.card.registeredAt": "Бүртгүүлсэн огноо:",
  "YouTubeTab.card.currentSubscribers": "Одоогийн бүртгэгчид",
  "YouTubeTab.card.currentVideos": "Одоогийн видео тоо",
  "YouTubeTab.card.currentTotalViews": "Одоогийн нийт үзэлт",
  "YouTubeTab.card.currentTotalComments": "Одоогийн нийт сэтгэгдэл",
  "YouTubeTab.chart.totalSubscribers": "Нийт бүртгэгчид",
  "YouTubeTab.chart.totalViews": "Нийт үзэлт",
  "YouTubeTab.chart.totalComments": "Нийт сэтгэгдэл",
  "YouTubeTab.chart.totalVideos": "Нийт видео",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Арын хэсгийн data/x_stats.json татах",
  "XTab.downloadJson": "x_stats.json татах",
  "XTab.loading": "X үзүүлэлтүүдийг ачааллаж байна...",
  "XTab.errorHint":
    "Хэрэв Token тохируулагдаагүй бол backend/.env дахь X_BEARER_TOKEN эсвэл TWITTER_BEARER_TOKEN-г тохируулж backend-ийг дахин асаана уу.",
  "XTab.header.totalFollowers": "Нийт дагагч (олон суваг, нэгж: 10k)",
  "XTab.header.totalEngagement":
    "Нийт оролцоо (сүүлийн 5 пост: Таалагдсан + Ретвит + Хариу + Ишлэл, нэгж: 10k)",
  "XTab.dist.followers": "Дагагчдын тархалт (10k)",
  "XTab.dist.engagement":
    "Оролцооны тархалт (сүүлийн 5 пост: Таалагдсан + Ретвит + Хариу + Ишлэл, 10k)",
  "XTab.card.currentFollowers": "Одоогийн дагагч",
  "XTab.card.currentFollowing": "Одоогоор дагаж буй",
  "XTab.card.currentTweets": "Одоогийн твитийн тоо",
  "XTab.card.recentLikes": "Сүүлийн лайкууд (сүүлийн 5 пост)",
  "XTab.card.recentRetweets": "Сүүлийн ретвитүүд (сүүлийн 5 пост)",
  "XTab.card.recentReplies": "Сүүлийн хариунууд (сүүлийн 5 пост)",
  "XTab.card.recentQuotes":
    "Сүүлийн харалтууд (агуулгын төвшинд, сүүлийн 5 пост)",
  "XTab.card.listed": "Жагсаалтад орсон тоо (суваг төвшинд)",
  "XTab.smallChart.followers": "Дагагч",
  "XTab.smallChart.tweets": "Твит",
  "XTab.smallChart.likes": "Сүүлийн лайкууд",
  "XTab.smallChart.retweets": "Сүүлийн ретвитүүд",
  "XTab.smallChart.replies": "Сүүлийн хариунууд",
  "XTab.smallChart.quotes": "Сүүлийн харалтууд (агуулгын төвшинд)",
  "XTab.smallChart.following": "Дагаж буй",
  "XTab.smallChart.listed": "Жагсаалтад орсон",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Үүсгэсэн сараар шүүх:",
  "Analytics.dashboardTitle": "Төслийн эрүүл мэндийн самбар",
  "Analytics.metric.completionRate": "Дуусалтын хувь",
  "Analytics.metric.teamVelocity": "Багийн хурд",
  "Analytics.metric.blockerRatio": "Саадын хувь",
  "Analytics.metric.workloadBalance": "Ачааллын тэнцвэр",
  "Analytics.charts.statusDistribution": "Төлөвийн тархалт",
  "Analytics.charts.statusByMonthPercent": "Сараар төлөв (хувь)",
  "Analytics.charts.priorityDistribution": "Нэн тэргүүний байдлын тархалт",
  "Analytics.charts.priorityByMonthPercent":
    "Сараар нэн тэргүүний байдал (хувь)",
  "Analytics.charts.functionTypeDistribution": "Үйлдлийн төрлийн тархалт",
  "Analytics.charts.functionTypeByMonthPercent": "Сараар үйлдлийн төрөл (хувь)",
  "Analytics.blocker.ownerPie":
    "Саатсан асуудал · Хариуцагчийн тархалт (цагираг)",
  "Analytics.blocker.ownerByMonth": "Саатсан асуудал · Хариуцагч сараар (хувь)",
  "Analytics.bug.ownerPie": "Алдааны асуудал · Хариуцагчийн тархалт (цагираг)",
  "Analytics.bug.ownerByMonth": "Алдааны асуудал · Хариуцагч сараар (хувь)",
  "Analytics.ownerWorkloadDistribution": "Багийн ажлын ачааллын хуваарилалт",
  "Analytics.mode.priority": "Нэн тэргүүний байдлаар",
  "Analytics.mode.status": "Төлөвөөр",
  "Analytics.mode.type": "Төрлөөр",
  "Analytics.blocker.attentionNeeded":
    "Яаралтай анхаарах шаардлагатай асуудлууд",
  "Analytics.common.status": "Төлөв",
  "Analytics.common.owner": "Хариуцагч",
  "Analytics.insights.sectionTitle": "Төслийн онош ба зөвлөмж",
  "Analytics.insights.efficiency.title": "Үр ашиг сайжруулах зөвлөмж",
  "Analytics.insights.efficiency.completionRate":
    "• Одоогийн дуусалтын хувь {{rate}}%, саадыг ажиглаарай",
  "Analytics.insights.efficiency.avgVelocity":
    "• Багийн дундаж хурд {{velocity}} даалгавар/хүн",
  "Analytics.insights.efficiency.workloadBalance":
    "• Ачааллын тэнцвэр {{balance}}%",
  "Analytics.insights.risk.title": "Эрсдэлийн сэрэмжлэл",
  "Analytics.insights.risk.blockerRatio": "• Саадын хувь {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 төвшний асуудлын хувь {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Нэн тэргүүний асуудлуудыг эхэлж шийдвэрлэ",

  // ===== Kanban i18n =====
  "Kanban.title": "Канбан харагдац",
  "Kanban.totalIssues": "Нийт {{count}} асуудал",
  "Kanban.searchPlaceholder":
    "Гарчиг, асуудлын дугаар, хариуцагч эсвэл хамтран ажиллагчийг хайх...",
  "Kanban.status.backlog": "Хүлээгдэж буй",
  "Kanban.status.inProgress": "Хийгдэж байна",
  "Kanban.status.blocked": "Саатсан / Баталгаажуулалт хүлээгдэж",
  "Kanban.status.reviewTest": "Шалгалт / Туршилт",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Асуудлын жагсаалт",
  "List.totalIssues": "Нийт {{count}} асуудал",
  "List.viewDetails": "Дэлгэрэнгүй харах",
  "List.openInNewWindow": "Шинэ цонхонд нээх",
  "List.empty.title": "Асуудал байхгүй",
  "List.empty.subtitle":
    "Ажлын урсгалаа эхлүүлэхийн тулд эхний асуудлаа үүсгэнэ үү",

  // ===== Assets Register i18n =====
  "Assets.title": "Хөрөнгийн бүртгэл",
  "Assets.totalSets": "Нийт багц",
  "Assets.table.employee": "Ажилтан",
  "Assets.table.setCount": "Багц",
  "Assets.table.model": "Загвар",
  "Assets.total": "Нийт",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Төслийн асуудал хөтлөлт",
  "LukkeyIssues.goToDemo": "Демо хуудсанд очих",
  "LukkeyIssues.githubProject": "GitHub Төсөл ↗",
  "LukkeyIssues.githubManageIssues": "Issues-г GitHub дээр шууд удирдах ↗",
  "LukkeyIssues.financeModel": "Санхүүгийн загвар",
  "LukkeyIssues.productCoreIssues": "Бүтээгдэхүүний цөм асуудлууд",
  "LukkeyIssues.stats.totalIssues": "📊 Нийт асуудал",
  "LukkeyIssues.stats.completed": "✅ Дууссан",
  "LukkeyIssues.stats.inProgress": "🔄 Хийгдэж байна",
  "LukkeyIssues.stats.pending": "⏳ Хүлээгдэж буй",
  "LukkeyIssues.stats.blocked": "🚫 Саатсан",
  "LukkeyIssues.stats.docs": "📚 Баримт бичиг",
  "LukkeyIssues.tabs.kanban": "Канбан харагдац",
  "LukkeyIssues.tabs.analytics": "Шинжилгээ",
  "LukkeyIssues.tabs.market": "Зах зээлийн самбар",
  "LukkeyIssues.tabs.assets": "Хөрөнгийн бүртгэл",
  "LukkeyIssues.shareToChatGPT": "LUKKEY.json-г ChatGPT-ээр нээх", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY Нууцлалын бодлого",
  "PrivacyPolicy.intro.p1":
    "LUKKEY-д бид нууцлалын хамгийн аюулгүй хэлбэр нь хэрэглэгчийн өөрийн гарт үргэлж байдаг нууцлал гэж үздэг.",
  "PrivacyPolicy.intro.p2":
    "Иймээс та LUKKEY-ийн тоног төхөөрөмжийн хүйтэн түрийвчийг эсвэл LUKKEY гар утасны аппликейшн (Апп)-ыг ашиглаж байгаа эсэхээс үл хамааран бид ганхашгүй нэг зарчмыг хатуу мөрддөг:",
  "PrivacyPolicy.intro.p3_strong":
    "Хэрэглэгч тодорхой, ил тод зөвшөөрөөгүй тохиолдолд бид хэрэглэгчийн ямар ч мэдээллийг цуглуулахгүй, хадгалахгүй, сервер рүү илгээхгүй.",
  "PrivacyPolicy.intro.p3_tail":
    "Ашиглалттай холбоотой бүх өгөгдөл зөвхөн хэрэглэгчийн төхөөрөмж дээр локалаар хадгалагдаж, LUKKEY эсвэл аливаа сервер рүү хэзээ ч дамжуулагдахгүй.",
  "PrivacyPolicy.intro.p4":
    "Энэхүү Нууцлалын бодлого нь бид уг зарчмыг хэрхэн баримталдгийг тайлбарлана.",

  "PrivacyPolicy.s1.title": "1. Хэрэглэх хүрээ",
  "PrivacyPolicy.s1.appliesTo": "Энэхүү Нууцлалын бодлого дараахад хамаарна:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY тоног төхөөрөмжийн хүйтэн түрийвч",
  "PrivacyPolicy.s1.item.app": "LUKKEY гар утасны аппликейшн (Апп)",
  "PrivacyPolicy.s1.principle":
    "Аль аль нь “тэг цуглуулалт, тэг илгээлт, зөвхөн локал хадгалалт” гэсэн нэгдсэн нууцлалын зарчмыг мөрдөнө.",

  "PrivacyPolicy.s2.title": "2. Бид ЦУГЛУУЛДАГГҮЙ мэдээлэл",
  "PrivacyPolicy.s2.desc":
    "Таны нууцлалыг хамгаалахын тулд бид хэрэглэгчийн мэдээллийг цуглуулахгүй, илгээхгүй, хадгалахгүй гэдгээ тодорхойлоод, үүнд (гэхдээ үүгээр хязгаарлагдахгүй):",
  "PrivacyPolicy.s2.li.identity":
    "Таних мэдээлэл: нэр, утасны дугаар, имэйл хаяг, шуудангийн хаяг",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Түрийвчийн мэдрэмтгий өгөгдөл: хувийн түлхүүр, мнемоник хэлц, keystore файл, түрийвчийн нууц үг",
  "PrivacyPolicy.s2.li.blockchain":
    "Блокчейн өгөгдөл: түрийвчийн хаяг, гүйлгээний түүх, хөрөнгийн мэдээлэл",
  "PrivacyPolicy.s2.li.behavior":
    "Ашиглалтын зан төлөв: аппын лог, товшилтын бичлэг, зан төлөвийн аналитик",
  "PrivacyPolicy.s2.li.technical":
    "Техникийн мэдээлэл: төхөөрөмжийн танигч, байршил, IP хаяг",
  "PrivacyPolicy.s2.inShort.title": "Товчхондоо:",
  "PrivacyPolicy.s2.inShort.desc":
    "Тоног төхөөрөмж болон Апп-д таны харж буй бүхэн зөвхөн таны төхөөрөмж дээр оршдог. LUKKEY түүнд нэвтрэх боломжгүй.",

  "PrivacyPolicy.s3.title":
    "3. Тоног төхөөрөмжийн хүйтэн түрийвчийн нууцлал ба аюулгүй байдлын загвар",
  "PrivacyPolicy.s3.desc":
    "LUKKEY хүйтэн түрийвч нь бүрэн оффлайн, найдвартай аюулгүй орчныг бүрдүүлдэг. Гол онцлогууд:",
  "PrivacyPolicy.s3.h1.title": "1. Цэргийн түвшний аюулгүй байдлын хардвер",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ гэрчилгэатай Secure Element",
  "PrivacyPolicy.s3.h1.l2": "Хардверийн түвшний бүрэн шифрлэгдсэн холбоо",
  "PrivacyPolicy.s3.h2.title": "2. Аюулгүй байдлын боломжууд",
  "PrivacyPolicy.s3.h2.l1": "Хурууны хээ танилт",
  "PrivacyPolicy.s3.h2.l2": "Нууцлалын горим",
  "PrivacyPolicy.s3.h2.l3": "Олон түрийвчийн тусгаарласан менежмент",
  "PrivacyPolicy.s3.h3.title": "3. Бүрэн тусгаарлалт",
  "PrivacyPolicy.s3.h3.l1": "Интернэт холболтгүй",
  "PrivacyPolicy.s3.h3.l2": "Дата кабелийн холболтгүй",
  "PrivacyPolicy.s3.h4.title": "4. Задалгаа-эсэргүүцэлтэй өөрийгөө устгах",
  "PrivacyPolicy.s3.h4.desc":
    "Төхөөрөмжийг задалсан, гэмтээсэн эсвэл хэвийн бус халдлагад өртсөн тохиолдолд Secure Element нь мэдрэмтгий өгөгдлийг автоматаар устгаж, хувийн түлхүүрүүдийг олборлохоос сэргийлдэг.",
  "PrivacyPolicy.s3.h5.title":
    "5. Мэдрэмтгий ажиллагааг зөвхөн Secure Element дотор гүйцэтгэнэ",
  "PrivacyPolicy.s3.h5.l1": "Түрийвч үүсгэх",
  "PrivacyPolicy.s3.h5.l2": "Түрийвч импортлох",
  "PrivacyPolicy.s3.h5.l3": "Гүйлгээ гарын үсэг зурах",
  "PrivacyPolicy.s3.h5.note":
    "Бүх мэдрэмтгий үйл явц 100% Secure Element дотор явагдаж, аливаа аюулгүй бус чип эсвэл санах ойд хэзээ ч ил байдаггүй.",
  "PrivacyPolicy.s3.h6.title":
    "6. Secure Element-ээс гадуур мэдрэмтгий өгөгдөл хадгалахгүй",
  "PrivacyPolicy.s3.h6.desc":
    "Төхөөрөмжийн аюулгүй бус санах ойн хэсэгт хувийн түлхүүр, мнемоник, эсвэл өөр ямар ч мэдрэмтгий мэдээлэл хадгалагдахгүй.",

  "PrivacyPolicy.s4.title":
    "4. LUKKEY Апп-ын нууцлал ба аюулгүй байдлын загвар",
  "PrivacyPolicy.s4.desc":
    "LUKKEY Апп нь зөвхөн мэдээлэл харагдуулах болон мэдэгдэл өгөхөд чиглэдэг. Түрийвчийн мэдрэмтгий өгөгдлийг боловсруулдаггүй.",
  "PrivacyPolicy.s4.n1.title": "1. Апп хийхГҮЙ зүйлс",
  "PrivacyPolicy.s4.n1.l1": "Блокчейн түрийвч үүсгэхгүй",
  "PrivacyPolicy.s4.n1.l2": "Блокчейн түрийвч импортлохгүй",
  "PrivacyPolicy.s4.n1.l3": "Хувийн түлхүүр эсвэл мнемоник хадгалахгүй",
  "PrivacyPolicy.s4.n1.l4": "Ямар ч хэрэглэгчийн өгөгдөл илгээхгүй",
  "PrivacyPolicy.s4.n1.l5":
    "Зан төлөвийн аналитик, зарын хяналт, өгөгдөл цуглуулалт хийхгүй",
  "PrivacyPolicy.s4.n2.title": "2. Апп хийДЭГ зүйлс",
  "PrivacyPolicy.s4.n2.l1":
    "Хардвераар зөвшөөрөгдсөн, олон нийтэд нээлттэй мэдээллийг харуулна",
  "PrivacyPolicy.s4.n2.l2":
    "Тус бүрийн зөвшөөрлийн зорилгыг тайлбарласан нууцлалын тохиргооны самбар өгнө",
  "PrivacyPolicy.s4.n2.l3":
    "Хэрэглэгч зөвшөөрлүүдийг хүссэн үедээ асаах/унтраах бүрэн хяналттай",
  "PrivacyPolicy.s4.n2.l4": "Мэдрэмтгий мэдээллийн маск/нуух боломж олгоно",
  "PrivacyPolicy.s4.n2.l5":
    "Зарим харагдац дээр скриншот/дэлгэц бичлэгийг идэвхгүй болгоно",
  "PrivacyPolicy.s4.n2.l6":
    "Локал тааруулалтаар сэжигтэй блокчейн хаягуудыг илрүүлнэ",
  "PrivacyPolicy.s4.n2.l7":
    "Аюултай URL, гэрээ, хаягийн жагсаалтыг тогтмол шинэчилнэ",
  "PrivacyPolicy.s4.n2.l8": "Шинэчлэл нэг чиглэлтэй: зөвхөн сервер → төхөөрөмж",
  "PrivacyPolicy.s4.n2.l9":
    "Шинэчлэлтийн явцад хэрэглэгчийн өгөгдөл хэзээ ч буцаан илгээгдэхгүй",
  "PrivacyPolicy.s4.n3.title": "3. Локал хадгалалт",
  "PrivacyPolicy.s4.n3.p1":
    "Апп нь UI-ийн тохиргоо, хэл, загвар зэрэг хувийн бус өгөгдлийг зөвхөн локалаар хадгална. Энэ өгөгдөл:",
  "PrivacyPolicy.s4.n3.l1": "илгээгддэггүй",
  "PrivacyPolicy.s4.n3.l2": "синк хийгддэггүй",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY-д нэвтрэх боломжгүй",

  "PrivacyPolicy.s5.title": "5. Өгөгдөл дамжуулалт ба серверийн бодлого",
  "PrivacyPolicy.s5.l1":
    "LUKKEY серверүүд хэрэглэгчийн ямар ч мэдээллийг хадгалдаггүй",
  "PrivacyPolicy.s5.l2":
    "Апп–серверийн холбоо нь зөвхөн өгөгдлийн сан болон хувилбарын шинэчлэлтээр хязгаарлагдана",
  "PrivacyPolicy.s5.l3":
    "Харилцааны явцад ямар ч хэрэглэгчийн мэдээлэл дамжуулахгүй",
  "PrivacyPolicy.s5.l4":
    "Сервер халдлагад өртсөн ч хэрэглэгчийн өгөгдөл алдагдахгүй — учир нь бид ийм өгөгдлийг огт авдаггүй",

  "PrivacyPolicy.s6.title": "6. Нээлттэй эхийн ил тод байдал",
  "PrivacyPolicy.s6.l1": "LUKKEY Апп-ын эх код нээлттэй",
  "PrivacyPolicy.s6.l2": "LUKKEY хардверын суулгагдсан фермвэр нээлттэй",
  "PrivacyPolicy.s6.l3":
    "Хэн дуртай нь шалгаж нягтлах боломжтойгоор GitHub-д бүрэн нийтэлсэн",
  "PrivacyPolicy.s6.p": "Ил тод байдал нь аюулгүй байдлын нэг хэсэг юм.",

  "PrivacyPolicy.s7.title": "7. Хэрэглэгчийн бүрэн хяналт",
  "PrivacyPolicy.s7.p":
    "Бид хэрэглэгчийн мэдээлэл цуглуулдаггүй ч хэрэглэгч өөрийн төхөөрөмж дээр бүрэн хяналттай хэвээр байна:",
  "PrivacyPolicy.s7.l1":
    "Та Апп-ын зөвшөөрлүүдийг хүссэн үедээ идэвхгүй болгож болно",
  "PrivacyPolicy.s7.l2":
    "Та Апп-ыг устгаснаар бүх локал Апп өгөгдлийг арилгана",
  "PrivacyPolicy.s7.l3":
    "Та хардвер төхөөрөмжийг reset хийж хувийн түлхүүр, түрийвчийн өгөгдлийг бүр мөсөн устгаж болно",
  "PrivacyPolicy.s7.p2":
    "LUKKEY эдгээр үйлдэлд оролцохгүй, мөн оролцох боломжгүй.",

  "PrivacyPolicy.s8.title": "8. Холбоо барих",
  "PrivacyPolicy.s8.p":
    "Хэрэв энэхүү Нууцлалын бодлоготой холбоотой асуулт байвал бидэнтэй дараах хаягаар холбогдоно уу:",
  "PrivacyPolicy.s8.email": "Имэйл: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Хаяг: LUKKEY Төв оффис, Baarerstrasse 25, 6300 Цуг, Швейцарь",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Шалгаж байна...",
  "EmailOtp.title":
    "Хандалт хязгаарлагдмал: нэвтрэх код авахын тулд нэр, имэйлээ оруулна уу",
  "EmailOtp.nameLabel": "Нэр",
  "EmailOtp.namePlaceholder": "Нэрээ оруулна уу",
  "EmailOtp.emailLabel": "Имэйл",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Код илгээх",
  "EmailOtp.resendCode": "Код дахин илгээх",
  "EmailOtp.resendWithCountdown": "{{s}} сек дараа дахин илгээх",
  "EmailOtp.codeValidityHint":
    "Баталгаажуулах код 5 минут хүчинтэй. Кодоо хэнд ч битгий хуваалцаарай.",
  "EmailOtp.codeLabel": "Имэйлийн баталгаажуулах код",
  "EmailOtp.codePlaceholder": "Хүлээн авсан кодоо оруулна уу",
  "EmailOtp.signIn": "Нэвтрэх",
  "EmailOtp.message.codeSent": "Баталгаажуулах код таны имэйл рүү илгээгдлээ.",
  "EmailOtp.error.nameRequired": "Нэр шаардлагатай",
  "EmailOtp.error.invalidEmail": "Хүчинтэй имэйл хаяг оруулна уу",
  "EmailOtp.error.sendFailed": "Код илгээхэд алдаа гарлаа",
  "EmailOtp.error.codeRequired": "Баталгаажуулах кодоо оруулна уу",
  "EmailOtp.error.verificationFailed": "Баталгаажуулалт амжилтгүй боллоо",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Аюулгүй байдлын сануулга: Холбоосыг үргэлж шалгаж, сэргээх үгээ хэзээ ч бүү хуваалц.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Академи",
  "Academy.hero.subtitle": "Крипто аюулгүй байдал, өөрийн хадгалалт болон LUKKEY хүйтэн түрийвчийн хэрэглээний практик заавар.",
  "Academy.search.placeholder": "Сургалт, шилдэг туршлага, ТТГ (FAQ) хайх…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "Нийтлэл",
  "Academy.list.title": "Шинэчилсэн зааврууд",
  "Academy.list.viewAll": "БҮГДИЙГ ХАРАХ",
  "Academy.list.empty": "Үр дүн алга. Өөр түлхүүр үгээр хайгаад үз.",
  "Academy.image.placeholder": "ЗУРАГ",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Академи руу буцах",
  "AcademyArticle.notFound": "Нийтлэл олдсонгүй",
  "AcademyArticle.author": "Зохиогч",
  "AcademyArticle.unscheduled": "Товлосон нийтлэх цаггүй",
  "home.hero.reserveCtaLabel": "Эрт хандалт — 1 ам.доллар",
  "home.hero.reserveCtaNote": "Бүрэн буцаан олголттой. Худалдан авах үүрэг хүлээхгүй."
};
export default translation;
